/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITiposDivisiones from 'Infotrack@Modelos/smartStock/tiposDivisiones/entidades/tiposDivisiones';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import TiposDivisionesCM from '../controladorModelo/tiposDivisionesCM';
import { IFormularioTiposDivisionesCVProps } from '../interfaces';
import { acciones, IEstadoTiposDivisiones } from '../reductorTiposDivisiones';
import FormularioTiposDivisionesVista from '../vista/formularioTiposDivisionesVista';
import { useSelector } from 'react-redux';
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';

const estadoInicial: ITiposDivisiones = {
    EmpresaId: '',
    TipoDivisionDescripcion: '',
    Estado: 1,
    AgenciaId: '',
};
const tiposDivisionesCM = new TiposDivisionesCM();

const FormularioTiposDivisionesCV: React.FunctionComponent<IFormularioTiposDivisionesCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadTiposDivisiones }, dispatch] = useProveedor<
        IEstadoTiposDivisiones
    >();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<ITiposDivisiones>(estadoInicial);

    React.useEffect(() => {
        if (entidadTiposDivisiones && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadTiposDivisiones);
        } else {
            reiniciar();
        }
    }, [entidadTiposDivisiones]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionTiposDivisiones = () => {
        if (tiposDivisionesCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarTiposDivisiones,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarTiposDivisiones = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            tiposDivisionesCM
                .crearTiposDivisiones({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            tiposDivisionesCM
                .editarTiposDivisiones({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioTiposDivisionesVista
            accionCrearEditar={confirmarCreacionEdicionTiposDivisiones}
            cambiarInfoFomulario={alCambiarValor}
            tiposDivisiones={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioTiposDivisionesCVProps => ({ IdEmpresa: usuarioInformacion!.IdEmpresa });

export default connect<IFormularioTiposDivisionesCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioTiposDivisionesCV);
